import Select from "react-select";

export function SeshSelect<
	F,
	T extends { label: string | JSX.Element; value: F }
>(props: {
	className?: string;
	label?: string | JSX.Element;
	value: T;
	options: T[];
	onChange: (new_value: T) => void;
	onInputChange?: (val: string) => void;
	is_disabled?: boolean;
	is_loading?: boolean;
}) {
	return (
		<div className={props.className}>
			{props.label && <label className="label">{props.label}</label>}
			<Select
				classNamePrefix="sesh-dropdown"
				onInputChange={props.onInputChange}
				value={props.value}
				options={props.options}
				onChange={(selected: T) => props.onChange(selected)}
				isDisabled={props.is_disabled}
				isLoading={props.is_loading}
			/>
		</div>
	);
}
